import { NgModule } from '@angular/core';
import { SignaturePadDirective } from './signature-pad.directive';

@NgModule({
  declarations: [SignaturePadDirective],
  exports: [SignaturePadDirective],
  imports: [],
})
export class SignaturePadModule {}
